<template>
  <div class="inline-flex items-center">
    <span
      class="inline-flex items-center rounded-full px-2 py-1 text-xs font-medium bg-muted text-muted-foreground"
    >
      <div class="mr-1 h-2 w-2 rounded-full" :class="themeDotClasses"></div>
      {{ themeText }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { watchSystemTheme, getSystemTheme, type Theme } from '@/lib/theme'

const currentTheme = ref<Theme>(getSystemTheme())
let themeUnwatch: (() => void) | null = null

const themeText = computed(() => {
  return currentTheme.value === 'dark' ? 'Dark' : 'Light'
})

const themeDotClasses = computed(() => {
  return currentTheme.value === 'dark' 
    ? 'bg-slate-600' 
    : 'bg-yellow-400'
})

onMounted(() => {
  themeUnwatch = watchSystemTheme((theme: Theme) => {
    currentTheme.value = theme
  })
})

onUnmounted(() => {
  if (themeUnwatch) {
    themeUnwatch()
  }
})
</script>
